// extracted by mini-css-extract-plugin
export default {"text":"DevicesRestrictionsNotification_text__SvNtQ","icon":"DevicesRestrictionsNotification_icon__RAZu9"};